import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const finish = async () => {
      try {
        const u = await loginWithGoogleSession(sessionId);
        window.history.replaceState(null, "", "/akun");
        toast.success(`Selamat datang, ${u.name}`);
      } catch (e) {
        window.history.replaceState(null, "", "/toko");
        toast.error(errMsg(e, "Gagal masuk dengan Google"));
      }
      navigate(window.location.pathname, { replace: true });
    };
    finish();
  }, [location.hash, loginWithGoogleSession, navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center text-muted-foreground"
      data-testid="google-auth-callback"
    >
      Memproses masuk dengan Google…
    </div>
  );
};
